import { render, staticRenderFns } from "./VueGauge.vue?vue&type=template&id=0794ff41&scoped=true"
import script from "./VueGauge.vue?vue&type=script&lang=js"
export * from "./VueGauge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794ff41",
  null
  
)

export default component.exports